export default __webpack_public_path__ + "static/media/javascript.08da15e8.png";